import axiosAgsc from "@/store/axiosAgsc";
const resource = "/PolicyReview";

export default {
  getPermissionLevels: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetPermissionLevels`, null);
  },
  getReviewStatuses: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetReviewStatuses`, null);
  },
  getRiskLevels: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetRiskLevels`, null);
  },
  proposedUniqueBlocks: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/ProposedUniqueBlocks`, payload);
  },
  listCheckList: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/ListCheckList`, payload);
  },
  createReview: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/CreateReview`, payload);
  },
  updateReview: (payload: any = {}): any => {
    return axiosAgsc.put(`${resource}/UpdateReview`, payload);
  },
  changeReviewStatus: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/ChangeReviewStatus`, payload);
  },
  getPolicyReviewDashboard: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetPolicyReviewDashboard`, payload);
  },
  getProposedUniqueBlocks: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/ProposedUniqueBlocks`, null);
  },
  getModes: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetModes`, null);
  },
  getScopes: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetScopes`, null);
  },
  getDecisionStatus: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetDecisionStatus`, null);
  },
  decisionOptions: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/DecisionOptions`, null);
  },
  getDecisions: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetDecisions`, null);
  },
};
